import { render, staticRenderFns } from "./AdministrationEditUserPasswordDialog.vue?vue&type=template&id=200d61a4"
import script from "./AdministrationEditUserPasswordDialog.vue?vue&type=script&lang=js"
export * from "./AdministrationEditUserPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports